<template>
    <div class="gmf-banner-slide" :style="containerStyle" @click="openSocialModal">
        <div class="gmf-banner-bg" v-if="bgStyle" :style="bgStyle"></div>
        <div class="gmf-banner-header" :style="headerStyle">
            <div class="gmf-header">{{ t('title') }}</div>
            <div class="gmf-text-small" v-if="t('subtitle')">{{ t('subtitle') }}</div>
        </div>
        <img :style="imageStyle" :src="imageUrl" @load="updateImageSize" role="presentation">
        <div class="gmf-banner-ball" v-if="t('bubble_text')">{{ t('bubble_text') }}</div>
        <a v-if="!hideButton && socialFeedUrl" class="gmf-btn gmf-btn-sm gmf-mt-4 gmf-btn-primary" :href="socialFeedUrl">{{ tt('new_comments_slideshow.show_more') }}</a>
        <button v-else-if="!hideButton" class="gmf-btn gmf-btn-sm gmf-mt-4 gmf-btn-primary" @click="ev => onClick(ev)">{{ tt('new_comments_slideshow.show_more') }}</button>
    </div>
</template>

<style>
.gmf-banner-slide-wrap {
    align-self: stretch !important;
    position: relative !important;
}

.gmf-banner-slide {
    position: absolute;
    inset: 0;
    background: var(--gmf-social-banner-col-bg);
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    cursor: pointer;

    --gmf-banner-image-popout: 24px;
}

.gmf-banner-header {
    padding: var(--gmf-p-5);
    padding-bottom: 0;

    flex: 0 0 auto;
    max-width: 100%;
    gap: var(--gmf-p-1);
    display: flex;
    flex-direction: column;

    z-index: 2;

    text-shadow: 0px 0px 6px var(--gmf-social-banner-col-bg);
}

.gmf-context .gmf-banner-header .gmf-header {
    margin: 0 !important;
}

.gmf-banner-header * {
    color: var(--gmf-social-banner-col-fg) !important;
}


.gmf-banner-slide img {
    flex: 0 1 auto;
    object-fit: cover;
    margin: auto;
    margin-bottom: 0;
    overflow: hidden;
    max-width: 100%;

    height: calc(100% + var(--gmf-banner-image-popout));
    margin-top: calc(0px - var(--gmf-banner-image-popout));
    z-index: 1;
}

.gmf-banner-slide .gmf-banner-ball {
    position: absolute;
    right: var(--gmf-p-4);
    bottom: calc(0px - var(--gmf-p-4));
    background: var(--gmf-social-banner-bubble-col-bg);
    color: var(--gmf-social-banner-bubble-col-fg) !important;
    padding: var(--gmf-p-4);
    font-weight: bold;
    font-family: var(--gmf-header-font);
    border-radius: 50%;
    aspect-ratio: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    transform: rotate(10deg);
    transform-origin: center;
    max-width: 120px;
    text-align: center;
    z-index: 1;
}
.gmf-banner-bg {
    background-size: cover;
    background-position: center;
    position: absolute;
    inset: 0;
    overflow: hidden;
}

.gmf-banner-slide .gmf-btn {
    position: absolute;
    left: 50%;
    bottom: var(--gmf-p-4);
    transform: translateX(-50%);
    z-index: 1;
}
</style>

<script>
import state from '@/state';
import elSize from '@/utils/mixins/elSize';
import openSocialModal from '@/widgets/SocialFeed/openSocialModal';

const t = state.t.prefix('social_banner');

export default {
    mixins: [elSize],
    props: ['hideButton'],
    data() {
        return {
            imageSize: null,
        };
    },
    methods: {
        t,
        tt: state.t,
        updateImageSize(evt) {
            const imgEl = evt.target;

            this.imageSize = {
                width: imgEl.naturalWidth,
                height: imgEl.naturalHeight,
            };
        },
        openSocialModal,
        onClick (ev) {
            ev.stopPropagation();
            ev.preventDefault();

            this.openSocialModal({
                displayHeader: true,
            });
            return false;
        }
    },
    computed: {
        bgStyle () {
            if (state.merchantConfig.widgets.socialBanner.backgroundImage) {
                return {
                    'background-image': `url(${state.merchantConfig.widgets.socialBanner.backgroundImage})`,
                };
            }
            return null;
        },
        imageUrl() {
            const sb = state.merchantConfig.widgets.socialBanner;
            if (sb.imageMobile && this.elSize.width < 768) {
                return sb.imageMobile;
            }
            return sb.image;
        },
        direction() {
            if (!this.imageSize) {
                return 'column';
            }

            const ratio = this.imageSize.width / this.imageSize.height;
            const expectedWidth = this.elSize.height * ratio;
            const maxExpectedWidth = this.elSize.width * 0.6;

            if (expectedWidth < maxExpectedWidth) {
                return 'row';
            }

            return 'column';
        },
        containerStyle() {
            return {
                'flex-direction': this.direction,
            };
        },
        headerStyle() {
            if (this.direction === 'row') {
                return {
                    'flex-shrink': '1',
                };
            }
            return {};
        },
        imageStyle() {
            if (this.direction === 'row') {
                return {
                    'flex-shrink': '0',
                };
            }
            return {};
        },
        socialFeedUrl() {
            return state.merchantConfig?.widgets?.urls?.socialFeed;
        }
    }
}
</script>